
<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "AJOUTER NOUVEAU CLIENT" : "MODIFIER LES INFORMATIONS DU CLIENT" }}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <form data-vv-scope="form-data">
      <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

        <div class="p-6 content-center">



          <!-- NAME -->
          <div class="vx-row mt-2">
            <div class="vx-col md:w-1/2 w-full">
                <vs-input label="Nom" v-model="dataLastname" class="mt-5 mr-1 w-full" name="lastname" />
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <vs-input label="Prénom" v-model="dataFirstname" class="mt-5 ml-1 w-full" name="firstname" v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('form-data.firstname')">{{ errors.first('form-data.firstname') }}</span>
            </div>
          </div>

          <div class="vx-row mt-2">
            <div class="vx-col md:w-1/2 w-full">
                <vs-input label="Company" v-model="dataCompany" class="mt-5 mr-1 w-full" name="company" />
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <vs-input label="Siret" v-model="dataSiret" class="mt-5 ml-1 w-full" name="siret" />
            </div>
          </div>

          <div class="vx-row mt-2">
            <div class="vx-col md:w-1/2 w-full">
                <vs-input label="Email" v-model="dataEmail" class="mt-5 mr-1 w-full" name="email" v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('form-data.email')">{{ errors.first('form-data.email') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <vs-input label="Téléphone" v-model="dataTel" class="mt-5 ml-1 w-full" name="tel" />
            </div>
          </div>

          <div class="vx-row mt-5">
              <div class="vx-col md:w-1/2 w-full">
                <vs-input label="Ville" v-model="dataCity" class="w-full" name="city" v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('form-data.city')">{{ errors.first('form-data.city') }}</span>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <vs-input label="Code postal" v-model="dataZipcode" class="w-full" name="zipcode" v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('form-data.zipcode')">{{ errors.first('form-data.zipcode') }}</span>
              </div>
          </div>

          <div class="vx-row mt-2">
            <div class="vx-col md:w-full w-full">
              <div class="vs-component vs-con-input-label vs-input   w-full vs-input-primary">
                  <label for="textarea-default" class="vs-input--label mt-5">Adresse</label>
                  <vs-textarea id="textarea-default" rows="3"  name="address" v-model="dataAddress" />
              </div>
            </div>
          </div>

        </div>
      </VuePerfectScrollbar>
    </form>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" >{{ Object.entries(this.data).length === 0 ? "Ajouter" : "Enregistrer" }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Annuler</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapActions } from 'vuex'

// For custom error message
import { Validator } from 'vee-validate';
const dict = {
  custom: {

    firstname : {
      required: 'Le prénom de client est obligatoire'
    },
    email : {
      required: 'L\'email de client est obligatoire'
    },
    city : {
      required: 'La ville de client est obligatoire'
    },
    zipcode : {
      required: 'Le code postal de client est obligatoire'
    },



  }
};

// register custom messages
Validator.localize('fr', dict);

export default {
  components: {
    VuePerfectScrollbar
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {

      dataId: null,
      dataLastname: null,
      dataFirstname: null,
      dataCompany: null,
      dataSiret: null,
      dataEmail: null,
      dataTel: null,
      dataAddress: null,
      dataCity: null,
      dataZipcode: null,
      settings: {
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
      customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }]]
    }
  },
  created () {

  },
  watch: {
    isSidebarActive(val) {
      if(!val) return
      if(Object.entries(this.data).length === 0) {
        this.initValues()
      }else {
        let { id, lastname, firstname,company,siret, email, tel, address, city, zipcode} = JSON.parse(JSON.stringify(this.data))

        this.dataId = id,
        this.dataLastname = lastname,
        this.dataFirstname = firstname,
        this.dataCompany= company,
        this.dataSiret = siret,
        this.dataEmail = email,
        this.dataTel = tel,
        this.dataAddress = address,
        this.dataCity = city,
        this.dataZipcode = zipcode,
        this.initValues()
      }

    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
          this.initValues(true)
        }
      },
    }
  },
  methods: {
    ...mapActions('clients', ['addItem','updateItem']),
    initValues(close = false) {
      if(close){
        this.dataId = null,
        this.dataLastname = null,
        this.dataFirstname = null,
        this.dataCompany = null,
        this.dataSiret = null,
        this.dataEmail = null,
        this.dataTel = null,
        this.dataAddress = null,
        this.dataCity = null,
        this.dataZipcode = null
        this.errors.items = []
        return
      }

      if(this.data.id) return

    },
    submitData() {
      const obj = {
        id: this.dataId,
        lastname: this.dataLastname,
        firstname: this.dataFirstname,
        company: this.dataCompany,
        siret: this.dataSiret,
        email: this.dataEmail,
        tel: this.dataTel,
        address: this.dataAddress,
        city: this.dataCity,
        codePostal: this.dataCodePostal
      }

      this.$validator.validateAll('form-data').then(result => {
        if (result) {
          if(this.dataId !== null && this.dataId >= 0) {

            this.$emit('showLoading')

            this.updateItem(obj).then(()=>{
            this.$emit('closeSidebar')
            this.initValues(true)
            this.$emit('closeLoading')

            this.successMsg("La modification","Client est bien modifié");

            }).catch(()=> {

                this.$emit('closeLoading')
                this.errorMsg('La modification','Veuillez vérifier pour modifier le client')
            })

          }else{
            this.$emit('showLoading')

            this.addItem(obj).then(()=>{
              this.$emit('closeSidebar')
              this.initValues(true)
              this.$emit('closeLoading')
              this.successMsg("L'ajout","Client est bien ajouté");

            }).catch(()=> {
              this.$emit('closeLoading')
              this.errorMsg('L\'Ajout','Veuillez vérifier pour ajouter un client')
            })

          }
        }else{
          return false
        }
      })

    },
    successMsg(title,msg){
      this.$vs.notify({
        title: title,
        text: msg,
        color:'success',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    },
    errorMsg(title,msg){
      this.$vs.notify({
        title: title,
        text: msg,
        color:'danger',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 700px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}

.icon svg {
  stroke: #B52141;
  stroke-width: 10;
  fill: #fff;
  background: #B52141;
  border-radius: 50%;
  padding: 10px;
}

.vs-switch {
  width: 80px !important;
}

</style>
